import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServicedeskPageContextResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { assetsReportsRoute } from '@atlassian/jira-router-routes-assets-routes/src/assetsReportsRoute.tsx';
import {
	toPackageName,
	APP_NAMES,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { assetsReportsNav4HomeEntryPoint } from '@atlassian/jira-spa-apps-servicedesk-cmdb-assets-reports/src/entrypoint.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';

const assetsReportsPageEntryPoint = createChromelessEntryPoint({
	main: assetsReportsNav4HomeEntryPoint,
});

export const assetsReportsRouteEntry = createEntry(assetsReportsRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: Spinner,
	entryPoint: () => assetsReportsPageEntryPoint,
	pageId: () => 'spa-apps/servicedesk/insight/cmdb-assets-reports-home-page',
	resources: [...getAssetsAppResources(), ...getServicedeskPageContextResources()],
	forPaint: [LazyAssetsLayout],

	meta: {
		reporting: {
			id: APP_NAMES.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
			packageName: toPackageName(APP_NAMES.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
			teamName: 'ITSM SAGA',
		},
	},

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsReportsRouteEntry.tsx',
			whichExportToUse: 'assetsReportsRouteEntry',
		},

		enabled: true,
	},
}));
